import styled from 'styled-components'

export const StyledSpecsJATOAcademyPopUp = styled.div``
